import { css, SimpleInterpolation } from 'styled-components';

export const contentOverlayStylesWithOpacity = (
  opacity: number
): SimpleInterpolation => css`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;

  background-color: black;
  opacity: ${opacity};
`;
